import { render, staticRenderFns } from "./DonutChart20.vue?vue&type=template&id=724adc6a&scoped=true&"
import script from "./DonutChart20.vue?vue&type=script&lang=js&"
export * from "./DonutChart20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724adc6a",
  null
  
)

export default component.exports